// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3O4ne","title":"Images45_title__2BjiZ","images":"Images45_images__1ARoK"};